import script from "./ProfilePicture.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePicture.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePicture.vue?vue&type=style&index=0&id=6618f7fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6618f7fa"]])

export default __exports__